import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OtherService {
  // state
  private isUserLogin = new BehaviorSubject(false);
  isUserLogin$ = this.isUserLogin.asObservable();

  // state
  private isSpecialistUserLogin = new BehaviorSubject<any>(null);
  isSpecialistUserLogin$ = this.isSpecialistUserLogin.asObservable();

  get specialistUser() {
    return this.isSpecialistUserLogin.value;
  }

  constructor() {
    // init state
    // extract the specialistInfo from localstorage and init its state
    this.initSpecialistUser();
  }

  changeUserLogin_Status(type: boolean) {
    this.isUserLogin.next(type);
  }

  changeSpecialistUserLogin_Status(type: any) {
    this.isSpecialistUserLogin.next(type);
  }

  logout() {
    sessionStorage.clear();
    localStorage.clear();
    this.changeUserLogin_Status(false);
    this.changeSpecialistUserLogin_Status(null);
  }

  initSpecialistUser() {
    const specialistInfo: string | null = localStorage.getItem('specialist-info');
    if (specialistInfo) {
      const initialValue = JSON.parse(specialistInfo);
      this.changeSpecialistUserLogin_Status(initialValue);
    }
  }

  getLocalStorage() {
    const userInfo = sessionStorage.getItem('info') || '{}';
    return JSON.parse(userInfo);
  }

  stringNumberToNumber(obj: any): any {
    const allowedWord = ['i', 'ti', 'f', 'd'];
    for (const key in obj) {
      if (typeof obj[key] === 'string') {
        const cleanedValue = obj[key].replace(/,/g, '');
        if (!isNaN(parseFloat(cleanedValue))) {
          for (const word of allowedWord) {
            if (key.startsWith(word)) {
              obj[key] = parseFloat(cleanedValue);
              break;
            }
          }
        }
      }
    }
    return obj;
  }
}